import classes from './DecisionSummary.module.scss'
import DecisionSingleValueTemplate from './DecisionSingleValueTemplate/DecisionSingleValueTemplate'
import DecisionMultipleValueTemplate from './DecisionMultipleValueTemplate/DecisionMultipleValueTemplate'
import _ from 'lodash'
import UlAccordion from '../../../../../components/ul-accordion/UlAccordion'
import { AccordionTab } from 'primereact/accordion'
import { useMemo, useState } from 'react'
interface DecisionSummaryProps {
  decisionSummaryData: any
  editData: any
}

const DecisionSummary = (props: DecisionSummaryProps) => {
  const [activeIndices, setActiveIndices] = useState<number[] | null>(null)

  const activeIndexMemo = useMemo(() => {
    if (
      props?.decisionSummaryData?.cert_attributes?.some((attr: any) => attr?.display_level_title)
    ) {
      const groupedAttributes = _(props?.decisionSummaryData?.cert_attributes)
        .groupBy(attr => attr.display_level_title)
        .keys()
        .value()

      const initialIndex =
        activeIndices !== null ? activeIndices : Array.from(Array(groupedAttributes.length).keys())

      return initialIndex
    }
  }, [props, activeIndices])

  const InlineRenderDecisionSummary = () => {
    if (!props?.decisionSummaryData?.cert_attributes) return <></>

    if (
      props?.decisionSummaryData?.cert_attributes?.some((attr: any) => attr?.display_level_title)
    ) {
      const groupedAttributes = _(props?.decisionSummaryData?.cert_attributes)
        .groupBy(attr => attr.display_level_title)
        .map((groupedAttr, index) => {
          return (
            <AccordionTab
              key={`unique-key-${index}`}
              header={index}
              headerClassName={`${classes['decision-summary-grouped-accordion-header']}`}
              contentClassName={`${classes['decision-summary-grouped-accordion-content']}`}
              tabIndex={0}
            >
              <div className={classes['decision-summary-grouped-accordion-items']}>
                {groupedAttr.map((attributeItem, index) => mapData(attributeItem, index, true))}
              </div>
            </AccordionTab>
          )
        })
        .value()

      return (
        <UlAccordion
          multiple
          className={`${classes['decision-summary-grouped-accordion']}`}
          activeIndex={activeIndexMemo}
          onTabChange={e => setActiveIndices(e.index as any)}
        >
          {groupedAttributes}
        </UlAccordion>
      )
    } else
      return props?.decisionSummaryData?.cert_attributes?.map((attribute: any, index: number) =>
        mapData(attribute, index, false)
      )
  }

  const mapData = (attribute: any, index: number, isGrouped: boolean) => {
    if (attribute?.max_value === '1') {
      const getValue = props?.editData?.find(
        (data: any) => data?.attribute_name === attribute.attribute_name
      )?.value
      return (
        <DecisionSingleValueTemplate
          key={`single-value-${index}-${attribute?.attribute_name}`}
          value={getValue && getValue.length > 0 ? getValue[0] : ''}
          attribute={attribute}
          isGrouped={isGrouped}
        />
      )
    }

    if (attribute?.max_value === 'n') {
      const getValues = props?.editData?.find(
        (data: any) => data?.attribute_name === attribute.attribute_name
      )?.value
      return (
        <DecisionMultipleValueTemplate
          key={`multiple-value-${index}-${attribute?.attribute_name}`}
          title={attribute?.display_name}
          attribute={attribute}
          values={getValues ?? []}
        />
      )
    }

    return <></>
  }

  return (
    <div className={classes['decision-summary-container']}>
      <InlineRenderDecisionSummary />
    </div>
  )
}

export default DecisionSummary
